import { render } from "./PaymentConfig.vue?vue&type=template&id=75da938e"
import script from "./PaymentConfig.vue?vue&type=script&lang=js"
export * from "./PaymentConfig.vue?vue&type=script&lang=js"

import "./PaymentConfig.vue?vue&type=style&index=0&id=75da938e&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__